import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import Modal from "react-bootstrap/Modal";
import "swiper/css/pagination";
import "swiper/css/effect-cards";
import { Zoom } from "react-reveal";

function Testimonials() {
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const [show4, setShow4] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);
    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);
    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);

    return (
        <div className="testimonials">
            <div>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Body>
                        <div className="modal-body custom-modal">
                            <div className="image-container">
                                <img className="principal-image" src="/testimonials/principal.png" alt="sfc principal" />
                            </div>
                            <br /> <br />
                            <h5 className="bold size-12">“Fill your paper with the breathings of your heart.” – William Wordsworth</h5>
                            <br />
                            <p>
                                Journaling can be very helpful for students for not only being more successful in class, but also have more confidence to take on life’s challenges. It boosts
                                confidence, inspires creativity, enhances critical thinking and improves physical and mental health.{" "}
                            </p>
                            <br />
                            <p>
                                To create a positive mindset among the students community, <span className="bold">SFS PUBLIC SCHOOL ICSE & ISC</span> has introduced{" "}
                                <span>Cradle to Classroom & A Jot a Day</span> by Better Life Projects for all the grades. We had a panel of faculties who thoroughly discussed and presented their
                                views on these books. With the myriad benefits of journaling, including improved sleep, decreased anxiety and better academic performance, keeping a journal seems like
                                something all the students should strive to do.
                            </p>
                            <br />
                            <p>
                                <span className="bold">A Jot a Day</span> journal invites you to record your thoughts and progress on specific problems or interest areas. It allows you to create
                                and maintain a dialogue with yourself about your goals - what they are, how you’ll reach them and your progress and challenges along the way. Articulating and tracking
                                your goals in writing makes them real, increasing your motivation and personal accountability.
                            </p>
                            <br />
                            <p>
                                If a twenty minute activity can improve your mental health or strengthen your writing skills or can be life changing, <span className="bold">why not go for it.</span>
                            </p>
                            <br />
                            <p>
                                I would like to congratulate <span className="bold">Ms. Sapna Prajapati</span> for her marvellous creation, expertly researched and well documented. I would like convey
                                my good wishes to her and would like to see more of her work in future.
                            </p>{" "}
                            <br />
                            <p className="bold">Rev. Dr. Jabamalai msfs</p>
                            <p className="bold">Principal</p>
                            <p className="bold">SFS PUBLIC SCHOOL ICSE & ISC</p>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={show2} onHide={handleClose2}>
                    <Modal.Body>
                        <div className="modal-body custom-modal">
                            <div className="image-container">
                                <img className="principal-image" src="/testimonials/lawrence.png" alt="sfs principal" />
                            </div>
                            <br /> <br />
                            <h5 className="bold size-12">“Give me the child for the first seven years and I'll give you the man.” – Aristotle</h5>
                            <br />
                            <p>
                                <span className="bold">SFS Academy</span> has always believed in true holistic growth of its students; and when this opportunity was presented, we realised the
                                importance of such initiatives and the long-term positive consequences of it on our students. We as a school have always appreciated changes to rudimentary systems and
                                have welcomed them. If such initiatives are not promoted voluntarily by schools, the overall wellbeing of a student could be compromised and that is not the true
                                purpose of education. Since, the introduction of <span className="bold">A Jot a Day and Cradle</span> to Classroom, we have understood the value and the appreciation
                                from parents, teachers, and students equally for presenting such concepts within education.
                            </p>
                            <br />
                            <p>
                                Journaling is a habit cultivated and promoted by some of the greats like Mark Twain, Anne Frank, Beethoven, Charles Darwin, etc., and we copiously want to utilise this
                                opportunity to ensure through journaling children are encouraged to regulate their thought processes and in turn enjoy its benefit through self-awareness, mindfulness,
                                and gratitude.
                            </p>
                            <br />
                            <p>
                                We strive to provide the best of education that is not only limited to academic content but also to support our students beyond the walls of the school. We, appreciate
                                The Better Life Projects for their creative approach in introducing a system that is completely focused on the overall student wellbeing.{" "}
                            </p>
                            <br />
                            <p>
                                They have ensured students at our school are supported appropriately to reap the benefits of this new yet indispensable project. We will continue to collaborate with
                                this organisation and wish them all the very best in their transformative aspirations.
                            </p>
                            <br />
                            <p>
                                SFS Academy wholeheartedly supports and endorses <span className="bold">The Better Life Projects</span>
                            </p>
                            <br />
                            <p className="bold">Rev. Fr. P Maria Lawrence</p>
                            <p className="bold">Principal</p>
                            <p className="bold">SFS PUBLIC SCHOOL ICSE & ISC</p>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={show3} onHide={handleClose3}>
                    <Modal.Body>
                        <div className="modal-body custom-modal">
                            <div className="image-container">
                                <img className="principal-image" src="/testimonials/anthony.png" alt="anthony principal" />
                            </div>
                            <br /> <br />
                            <p>
                                St. Francis School ICSE, Koramangala has always aimed to change the status quo in education by building a school that is idealistic, honest, and ethical so our learners
                                can be the same. Our children do well at academics but must fight the precociousness foisted upon them by a rapidly changing world by recognizing their privilege and
                                questioning their impact with authenticity. St. Francis hopes to do this by asking more of our learners, teachers and parents.
                            </p>
                            <br />
                            <p>
                                We design our beyond academic programmes carefully to help form strong, capable individuals, and when The Better Life Projects presented us with the Journaling Project
                                Programme, very quickly we realised that this project fits perfectly in line with the ethos of St. Francis School ICSE.
                            </p>
                            <br />
                            <p>
                                Through the Journaling Project Programme, our young students are exposed to a variety of thought provoking, norm-questioning, character building prompts through which
                                they develop their decision making, interpersonal, leadership, and skills that will be useful in the longer run of life. Cradle-to-Classroom for students in Grade 1 and
                                2, and A Jot a Day for students from Grade 3 to 10 are conducted within classrooms and in an environment that fosters an intrinsic motivation to do better each day,
                                students discover and showcase individual talents, pursue special interests, work in collaboration and achieve what they previously thought might be impossible. The
                                Better Life Projects with their journaling programme have made self-discovery of our students a wonderful journey.
                            </p>
                            <br />
                            <p>
                                I, wholeheartedly support and endorse the initiative that has given us an opportunity to instill hope in students that is beyond the books. Though adacemics is a
                                priority, the true purpose of education is to prepare the young to educate themselves throughout their lives, and we are proud to say that we are helping them with this
                                one little step at a time with the help of The Better Life Projects.
                            </p>
                            <br />
                            <p className="bold">Anthony D Vayalils</p>
                            <p className="bold">Principal</p>
                            <p className="bold">St. Francis School ICSE, Koramangala</p>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={show4} onHide={handleClose4}>
                    <Modal.Body>
                        <div className="modal-body custom-modal">
                            <div className="image-container">
                                <img className="principal-image" src="/testimonials/sandhya.png" alt="sr sandhya principal" />
                            </div>
                            <br /> <br />
                            <h5 className="bold size-12">MENTAL HEALTH AND SCHOOLS</h5>
                            <br />
                            <p>
                                Compare a school with a beehive, a honey comb. Except the queen, all others are busy building up the hive, gathering pollen, churning out honey, building relationships;
                                all working for the welfare of the community. The queen bee is comparable to the spirit or soul of the school, and the honey, the sweet product of everyone's labour.
                            </p>
                            <br />
                            <p>
                                Our School's primary objective is to create a healthy school climate where self-confident, purpose-driven persons of integrity are shaped, who in turn will contribute
                                to build a new tomorrow of justice, peace and respect for creation. We strive to provide opportunities for free and fearless expression of oneself which I believe is
                                crucial in the wholesome formation of an individual.
                            </p>
                            <br />
                            <p>
                                The Better Life Project (BLP) aims at creating a non-threatening and safe comfort zone for school children. The students both young and old find a platform to express
                                their inner world in the fun-filled journal writing once a week – all private and personal. This activity can bring healing to some, to others relief and to some others
                                lots of creativity and fun.
                            </p>
                            <br />
                            <p>
                                I find children waiting for the BLP class – a sure indication of a movement towards positivity and desire to relate to oneself intensely and deeply. The self-awareness
                                they gain indirectly from the fun-filled journal writing makes them more self-affirmed, confident and free.
                            </p>
                            <br />
                            <p>
                                I appreciate the vision of Ms. Sapna Prajapathi to understand the need of a wholesome mental health formation in school children which I feel is the decisive remedy for
                                many societal maladies. The BPL program largely helps in regaining social wellness.
                            </p>
                            <br />
                            <p>I wish her and team success and lasting contentment.</p>
                            <br />
                            <p className="bold">Sr. Sandhya</p>
                            <p className="bold">Principal</p>
                            <p className="bold">Notre Dame Academy</p>
                            <p className="bold">Bangalore</p>
                        </div>
                    </Modal.Body>
                </Modal>
                <Zoom left>
                    <h2 className="home-heading" style={{ webkitTextStroke: "3px #FF0000", color: "black", fontSize: 115, textAlign: "end", margin: "0px 80px 20px 0" }}>
                        Testimonials
                    </h2>
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        pagination={{
                            type: "fraction"
                        }}
                        navigation={false}
                        loop
                        autoplay={{ delay: 5500 }}
                        speed={1000}
                        spaceBetween={0}
                        slidesPerView={1}
                    >
                        <SwiperSlide>
                            <div className="reviews">
                                <p>
                                    "St. Francis School ICSE, Koramangala has always aimed to change the status quo in education by building a school that is idealistic, honest, and ethical so our
                                    learners can be the same. Our children do well at academics but must fight the precociousness foisted upon them by a rapidly changing world by recognizing their
                                    privilege and questioning their impact with authenticity."
                                </p>
                                <span onClick={handleShow3} className="read-more">
                                    Read more...
                                </span>
                                <div className="customer-info">
                                    <img alt="user" className="user-image" src="/testimonials/anthony.png" />
                                    <div className="customer-name">
                                        <h3>Anthony D Vayalils</h3>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="reviews">
                                <p>
                                    "Compare a school with a beehive, a honey comb. Except the queen, all others are busy building up the hive, gathering pollen, churning out honey, building
                                    relationships; all working for the welfare of the community. The queen bee is comparable to the spirit or soul of the school, and the honey, the sweet product of
                                    everyone's labour."
                                </p>
                                <span onClick={handleShow4} className="read-more">
                                    Read more...
                                </span>
                                <div className="customer-info">
                                    <img alt="user" className="user-image" src="/testimonials/sandhya.png" />
                                    <div className="customer-name">
                                        <h3>Sr. Sandhya</h3>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="reviews">
                                <p>
                                    "My kids (9-year-old twins) have just received their journals and are very excited about it. It was a gift from their aunt. We have also started our 5-minute
                                    gratitude walk every night after dinner. Thanks for introducing journal writing to my children and the lovely motivation to keep it going."
                                </p>
                                <div className="customer-info">
                                    <img alt="user" className="user-image" src="/icons/user.png" />
                                    <div className="customer-name">
                                        <h3>Usha Mani Munshi</h3>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="reviews">
                                <p>
                                    "Journaling can be very helpful for students for not only being more successful in class, but also have more confidence to take on life’s challenges. It boosts
                                    confidence, inspires creativity, enhances critical thinking and improves physical and mental health."
                                </p>
                                <span onClick={handleShow} className="read-more">
                                    Read more...
                                </span>
                                <div className="customer-info">
                                    <img alt="user" className="user-image" src="/testimonials/principal.png" />
                                    <div className="customer-name">
                                        <h3>Rev. Dr. Jabamalai msfs</h3>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="reviews">
                                <p>
                                    "SFS Academy has always believed in true holistic growth of its students; and when this opportunity was presented, we realised the importance of such initiatives
                                    and the long-term positive consequences of it on our students. "
                                </p>
                                <span onClick={handleShow2} className="read-more">
                                    Read more...
                                </span>
                                <div className="customer-info">
                                    <img alt="user" className="user-image" src="/testimonials/lawrence.png" />
                                    <div className="customer-name">
                                        <h3>Rev. Fr. P Maria Lawrence</h3>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="reviews">
                                <p>
                                    "I have not seen a creative concept as such on the market. The idea of giving back to the society and positive memory compilation is beyond exemplary. The fact that
                                    this organisation has a story behind it and it's fight against stigma on mental health makes it all the more relatable to someone like me who likes to document
                                    almost everything in my life as a form of therpy."
                                </p>
                                <div className="customer-info">
                                    <img alt="user" className="user-image" src="/testimonials/vishnu.png" />
                                    <div className="customer-name">
                                        <h3>Vishnu</h3>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="reviews">
                                <p>
                                    "Possibly the best gift I could give my niece who is about to sit her boards. This has helped her in exploring her own expectations as a student. Given the crucial
                                    year that it is for these youngsters, a journal like this is paramount and I would highly recommend anyone who has a teenager at home to introduce them to this
                                    concept."
                                </p>
                                <div className="customer-info">
                                    <img alt="user" className="user-image" src="/testimonials/shruthi.png" />
                                    <div className="customer-name">
                                        <h3>Shruthi</h3>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="reviews">
                                <p>
                                    "An absolutely brilliant product that targets to understand grassroot issues in children. It is surprising that schools are not including such initiatives in their
                                    curriculum even in 2021."
                                </p>
                                <div className="customer-info">
                                    <img alt="user" className="user-image" src="/testimonials/varun.png" />
                                    <div className="customer-name">
                                        <h3>Varun Shetty</h3>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="reviews">
                                <p>" Thank you for bringing the concept of journaling. This has helped me through the highs and lows of life especially during the pandemic "</p>
                                <div className="customer-info">
                                    <img alt="user" className="user-image" src="/testimonials/akash.png" />
                                    <div className="customer-name">
                                        <h3>Akash</h3>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </Zoom>
            </div>
        </div>
    );
}

export default Testimonials;
